import { API } from '@/shared/api/modules';
import type { GetAlertsPerResidentRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getAlertsPerResidentQueryOptions = (
  params: GetAlertsPerResidentRequestDto
) =>
  queryOptions({
    queryKey: ['alerts-per-resident', params],
    queryFn: async ({ signal }) =>
      await API.facilities.getAlertsPerResident(params, { signal }),
    placeholderData: keepPreviousData,
    enabled: !!params.from && !!params.to,
  });
